import { createFetchReducer, FetchingReducerState } from 'store/setLocalStore';
import * as actions from './actions';
import { MyDoctorsDto } from './types';

const myDoctorsReducer = createFetchReducer<MyDoctorsDto[]>(actions.GET_MY_DOCTORS, false);
export type PreferredDoctorState = FetchingReducerState<MyDoctorsDto[]>;

export const preferenceInitialState: PreferredDoctorState = {
  isFetching: false,
  error: null
};

export default myDoctorsReducer;
